

import React, { useState } from "react";
import {
    Toast,
    ToastContainer,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const INFO_TIMEOUT = 5

const Error = {
    header: <strong className="me-auto">
        Error
    </strong>,
    bg: "danger"
}

const Info = {
    header: <strong className="me-auto">
        Information
    </strong>,
    bg: "Info"
}

const RenderMessage = (type, text, time) => {
    const [showA, setShow] = useState(false);
    const toggleShow = () => setShow(!showA);
    return (
        <div className="relative">
            <ToastContainer>
                <Toast
                    bg={type.bg}
                    autohide={time}
                    show={showA}
                    onClose={toggleShow}>

                    <Toast.Header>
                        {type.header}
                    </Toast.Header>
                    <Toast.Body>
                        {text}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div> 
    )
  }

export const message = {
    info: (text) => RenderMessage( Info,text, INFO_TIMEOUT),
    error: (error) => RenderMessage( Error,error, INFO_TIMEOUT)
}